import { render, staticRenderFns } from "./DetailInternalMemo.vue?vue&type=template&id=3da54231"
import script from "./DetailInternalMemo.vue?vue&type=script&lang=js"
export * from "./DetailInternalMemo.vue?vue&type=script&lang=js"
import style0 from "./DetailInternalMemo.vue?vue&type=style&index=0&id=3da54231&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports